<template>
    <v-container>
        <v-data-table :headers="headers" :items="items" :search="search" class="elevation-1">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Trzby</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                        hide-details></v-text-field>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialog" max-width="600px">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                                Nova trzba
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="text-h5">{{ formTitle }}</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-text-field v-model="editedItem.period"
                                                label="Perioda"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model="editedItem.actual" label="Naozaj" type="number"
                                                prefix="€"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model="editedItem.forecast" label="Predpopklad" type="number"
                                                prefix="€"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model="editedItem.payoutPercentage"
                                                label="Vyplata %" type="number" suffix="%"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field v-model="editedItem.payoutAmount" label="Vyplata"
                                                type="number" prefix="€"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Zrusit</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Ulozit</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import { APIService } from "@/http/APIService.js";
const apiService = new APIService();

export default {
    data: () => ({
        dialog: false,
        search: '',
        headers: [
            { text: 'ID', value: 'id' },
            { text: 'Perioda', value: 'period' },
            { text: 'Naozaj', value: 'actual' },
            { text: 'Predpoklad', value: 'forecast' },
            { text: 'Vyplata %', value: 'payoutPercentage' },
            { text: 'Vyplata', value: 'payoutAmount' },
            { text: 'Vytvorene', value: 'created_at' },
            { text: 'Akcie', value: 'actions', sortable: false },
        ],
        items: [],
        editedIndex: -1,
        editedItem: {
            period: '',
            actual: 0,
            forecast: 0,
            payoutPercentage: 0,
            payoutAmount: 0,
        },
        defaultItem: {
            period: '',
            actual: 0,
            forecast: 0,
            payoutPercentage: 0,
            payoutAmount: 0,
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'New Revenue' : 'Edit Revenue';
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
    },

    created() {
        this.initialize();
    },

    methods: {
        initialize() {
            apiService.getAdminInvestmentRevenues('', '', 100, 0).then(response => {
                this.items = response.results;
            });
        },

        editItem(item) {
            this.editedIndex = this.items.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        deleteItem(item) {
            if (confirm('Naozaj chcete zmazat?')) {
                apiService.deleteAdminInvestmentRevenue(item).then(() => {
                    this.initialize();
                });
            }
        },

        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        save() {
            if (this.editedIndex > -1) {
                apiService.updateAdminInvestmentRevenue(this.editedItem).then(() => {
                    this.initialize();
                });
            } else {
                apiService.createAdminInvestmentRevenue(this.editedItem).then(() => {
                    this.initialize();
                });
            }
            this.close();
        },
    },
};
</script>